<template>
  <v-app style="background-color: #f8f9fb">
    <v-divider></v-divider>
    <br /><br />

    <v-container
      style="background-color: #eee"
      id="comissoes-recebidas"
      fluid
      tag="section"
    >
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-cash-multiple"
            title="Comissões Recebidas"
            color="rgb(71 130 180)"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <v-form ref="form">
              <v-row style="margin-top: 1rem" align="center">
                <v-col cols="12" sm="6" md="4">
                  <span>Empresa</span>
                  <v-select
                    v-model="filtros.empresa"
                    :items="empresasFiltradas"
                    label="Empresa"
                    multiple
                    dense
                    solo-inverted
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <span> Competência</span>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="competenciaFormatada"
                        label="Mês/Ano"
                        dense
                        solo-inverted
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>

                    <v-date-picker
                      v-model="competenciaRaw"
                      type="month"
                      no-title
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <span>Tipo</span>
                  <v-select
                    v-model="filtros.tipo"
                    :items="tipos"
                    label="Tipo"
                    dense
                    solo-inverted
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6" md="2">
                  <v-btn
                    color="primary"
                    small
                    :loading="loading"
                    @click="buscarComissoes"
                    :disabled="!filtros.empresa || filtros.empresa.length === 0"
                    style="margin-top: 24px"
                  >
                    <v-icon left small>mdi-magnify</v-icon>
                    Buscar
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>

            <v-progress-linear
              v-if="loading"
              indeterminate
              color="rgb(71 130 180)"
            ></v-progress-linear>

            <div
              v-if="!loading && comissoes.length === 0"
              class="text-center pa-8 grey--text"
            >
              Nenhuma comissão encontrada
            </div>

            <v-expansion-panels
              v-if="!loading && comissoes.length > 0"
              class="mt-4 pb-12"
              v-model="panelAberto"
            >
              <v-expansion-panel
                v-for="lote in comissoes"
                :key="lote.id"
                class="expansion-panel"
              >
                <v-expansion-panel-header>
                  <v-row no-gutters align="center">
                    <v-col cols="12" sm="2">
                      <v-chip small color="primary" text-color="white">
                        Fechamento #{{ lote.id }}
                      </v-chip>
                    </v-col>
                    <v-col cols="12" sm="2">
                      <v-chip
                        small
                        :color="getModeloColor(lote.modelo)"
                        text-color="white"
                      >
                        {{ lote.modelo }}
                      </v-chip>
                    </v-col>
                    <v-col cols="12" sm="2">
                      <v-chip
                        small
                        :color="getStatus(lote.empresa)"
                        text-color="white"
                      >
                        {{ lote.empresa }}
                      </v-chip>
                    </v-col>
                    <v-col cols="12" sm="2">
                      <strong>{{ lote.competencia }}</strong>
                    </v-col>
                    <v-col cols="12" sm="2" class="text-right">
                      <strong style="color: green">{{
                        formatarValor(lote.valorTotal)
                      }}</strong>
                    </v-col>
                    <v-col cols="12" sm="2" class="text-right">
                      <v-icon small class="mr-1">mdi-account-group</v-icon>
                      {{ lote.quantidadeColaboradores }} colaboradores
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <v-card outlined class="mt-2 mb-3 pa-3" rounded="lg">
                    <v-row>
                      <v-col cols="12" md="6">
                        <div class="text-caption grey--text">
                          Finalizado por
                        </div>
                        <div class="text-body-2">
                          <strong>{{ lote.insertBy }}</strong>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="text-caption grey--text">
                          Data de Finalização
                        </div>
                        <div class="text-body-2">
                          <strong>{{ formatarData(lote.data_insert) }}</strong>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>

                  <v-data-table
                    :headers="headersItens"
                    :items="lote.itens"
                    :items-per-page="10"
                    class="elevation-0"
                  >
                    <template v-slot:item="row">
                      <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                        <td>{{ row.item.id }}</td>
                        <td>{{ row.item.nomeColaborador }}</td>
                        <td>{{ formatarCPF(row.item.cpfColaborador) }}</td>
                        <td>
                          <v-chip
                            x-small
                            :color="getStatus(row.item.empresaColaborador)"
                            text-color="white"
                          >
                            {{ row.item.empresaColaborador }}
                          </v-chip>
                        </td>
                        <td style="text-align: right">
                          {{ formatarValor(row.item.valorPago) }}
                        </td>
                        <td>{{ row.item.data_insert }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn icon small v-bind="attrs" @click="snackbar.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import comissaoService from "@/services/comissao";

export default {
  name: "ComissoesRecebidas",

  data() {
    const hoje = new Date();
    const mesAtual = String(hoje.getMonth()).padStart(2, "0");
    const anoAtual = hoje.getFullYear();

    return {
      loading: false,
      comissoes: [],
      menu: false,
      competenciaRaw: `${anoAtual}-${mesAtual}`,
      panelAberto: 0,
      snackbar: {
        show: false,
        text: "",
        color: "info",
        timeout: 3000,
      },
      filtros: {
        empresa: ["Todas"],
        tipo: "Todos",
      },
      tipos: ["Todos", "ACORDOS", "VENDAS", "ENTREGAS", "FUNERARIA"],
      empresas: [
        "Todas",
        "PREVIDA",
        "MEMORIAL PARQUE MACEIO",
        "PARQUE DAS FLORES",
        "PARQUE DO AGRESTE",
        "CEMITERIO PREVIDA",
        "CEMITERIO PREVIDA SAO MIGUEL",
      ],
      headersItens: [
        { text: "ID", value: "id", width: "80px" },
        { text: "Colaborador", value: "nomeColaborador", width: "300px" },
        { text: "CPF", value: "cpfColaborador", width: "150px" },
        { text: "Empresa", value: "empresaColaborador", width: "150px" },
        {
          text: "Valor Pago",
          value: "valorPago",
          width: "120px",
          align: "right",
        },
        { text: "Data", value: "data_insert", width: "100px" },
      ],
    };
  },

  computed: {
    empresasFiltradas() {
      return this.empresas.filter((empresa) => this.hasPermission(empresa));
    },

    competenciaFormatada: {
      get() {
        if (!this.competenciaRaw) return "";
        const [ano, mes] = this.competenciaRaw.split("-");
        return `${mes}/${ano}`;
      },
      set(value) {
        if (!value) {
          this.competenciaRaw = "";
          return;
        }
        const [mes, ano] = value.split("/");
        this.competenciaRaw = `${ano}-${mes}`;
      },
    },
  },

  methods: {
    getModeloColor(modelo) {
      const cores = {
        VENDAS: "green",
        ACORDOS: "blue",
        ENTREGAS: "purple",
        FUNERÁRIA: "#5B4B8A",
        Todos: "#607D8B",
      };

      return cores[modelo] || "grey";
    },
    hasPermission(empresa) {
      const user = JSON.parse(sessionStorage.getItem("user"));
      if (!user || !user.roles) return false;

      if (user.roles.includes("ROLE_ADMIN")) {
        return true;
      }

      if (empresa === "Todas") {
        return true;
      }
      const requiredRoles = empresa
        .split(" ")
        .map((name) => "ROLE_" + name.trim().toUpperCase().replace(/\s/g, "_"));

      return requiredRoles.some((role) => user.roles.includes(role));
    },

    getStatus(status) {
      const status_formatado = status.toUpperCase();
      switch (status_formatado) {
        case "PARQUE DAS FLORES":
          return "orange darken-2";
        case "CEMITERIO PREVIDA":
          return "blue lighten-1";
        case "MEMORIAL PARQUE MACEIÓ":
          return "green lighten-1";
        case "PARQUE DO AGRESTE":
          return "cyan lighten-1";
        case "PREVIDA":
          return "blue lighten-1";

        default:
          "success";
      }
    },

    async buscarComissoes() {
      if (!this.competenciaRaw) {
        this.showSnackbar("Selecione a competência", "warning");
        return;
      }

      if (!this.filtros.empresa || this.filtros.empresa.length === 0) {
        this.showSnackbar("Selecione pelo menos uma empresa", "warning");
        return;
      }

      this.loading = true;

      try {
        const [ano, mes] = this.competenciaRaw.split("-");
        const competencia = `${mes}/${ano}`;
        const empresa = this.filtros.empresa.join(",");
        const tipo = this.filtros.tipo;

        const response = await comissaoService.buscarLoteComItens(
          competencia,
          tipo,
          empresa,
        );

        this.comissoes = response.data || [];

        if (this.comissoes.length === 0) {
          this.showSnackbar(
            "Nenhuma comissão encontrada para os filtros selecionados",
            "info",
          );
        }
        this.loading = false;
      } catch (error) {
        console.error("Erro ao buscar comissões:", error);
        this.showSnackbar(
          error.response?.data?.message || "Erro ao buscar comissões",
          "error",
        );
      } finally {
        this.loading = false;
      }
    },

    formatarValor(valor) {
      if (!valor && valor !== 0) return "-";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(valor);
    },

    formatarCPF(cpf) {
      if (!cpf) return "-";
      const cpfString = cpf.toString().padStart(11, "0");
      return cpfString.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },

    formatarData(data) {
      if (!data) return "-";
      const date = new Date(data);
      return date.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    showSnackbar(text, color = "info", timeout = 3000) {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.timeout = timeout;
      this.snackbar.show = true;
    },
  },

  mounted() {
    this.buscarComissoes();
  },
};
</script>

<style scoped>
.cor-row {
  background-color: rgb(231 244 255);
  transition: none !important;
}

.expansion-panel {
  border-radius: 8px;
  border: 1px solid rgb(224 224 224);
}
</style>
